module.exports = __webpack_public_path__ + "static/media/skyscraper.01cd7e14.jpg";